// Preview what `avatar sync` would do, without modifying filesystem.
//
// v3: pack là tarball (không git) → không còn git log diff. So version manifest
// hiện tại vs target. mountDir status không đổi (symlink farm pack-agnostic).
import { join } from "node:path";

import { pathExists } from "./filesystem-helpers.js";
import { readPackVersionFromFile } from "./pack-manifest-store.js";
import { TEAM_PACK_MOUNT_DIRS } from "./symlink-farm-for-team-pack-mount-dirs.js";

export interface SyncPreview {
  currentVersion: string;
  targetVersion: string;
  mountDirStatuses: Array<{ dir: string; status: string }>;
}

// Look up which mount dirs already have symlinks vs missing vs conflict.
async function inspectMountDir(packDir: string, claudeDir: string, dir: string): Promise<string> {
  const source = join(packDir, dir);
  const dest = join(claudeDir, dir);
  if (!(await pathExists(source))) return "source-missing";
  if (!(await pathExists(dest))) return "needs-creation";
  const { promises: fs } = await import("node:fs");
  const st = await fs.lstat(dest);
  if (st.isSymbolicLink()) return "already-linked";
  return "conflict-real-dir";
}

export async function buildSyncPreview(
  packDir: string,
  claudeDir: string,
  targetVersion?: string,
): Promise<SyncPreview> {
  // v3: version hiện tại đọc từ manifest. target = version pin (nếu có) hoặc
  // "stable mới nhất" (server resolve — client không biết trước số cụ thể).
  const currentVersion = (await readPackVersionFromFile(packDir)) ?? "(chưa cài)";
  const target = targetVersion ?? "stable mới nhất (server resolve)";

  const mountStatuses = [];
  for (const dir of TEAM_PACK_MOUNT_DIRS) {
    mountStatuses.push({
      dir,
      status: await inspectMountDir(packDir, claudeDir, dir),
    });
  }

  return {
    currentVersion,
    targetVersion: target,
    mountDirStatuses: mountStatuses,
  };
}
